import type { ReactNode } from "react";

export interface CtaPillProps {
  /** Icono a la izquierda. Decorativo: el texto ya dice lo mismo. */
  icon?: ReactNode;
  children: ReactNode;
}

/**
 * La píldora que corona el bloque de CTA — el "⭐ Comienza hoy" del
 * sistema actual. Va sobre fondo oscuro, de ahí el borde y el texto en
 * blanco translúcido.
 */
export function CtaPill({ icon, children }: CtaPillProps) {
  return (
    <span className="inline-flex items-center gap-2 rounded-ds-pill border border-white/20 bg-white/10 px-3.5 py-1.5 text-ds-label font-bold uppercase tracking-ds-label-wide text-white/80">
      {icon && (
        <span aria-hidden="true" className="inline-flex [&>svg]:h-3.5 [&>svg]:w-3.5">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
